//全局状态
import * as digital from "../../utils/digital";
import { post, get, post1 } from "../../api/ajax";
import { logger } from "../../utils/log"; //日志
const state = {
  loading: false, //列表加载状态
  settleList: [], //需处理的数据
  successListLen: 0, //处理成功的数据
  failList: [], //处理失败的数据
  process: 0, //当前进度位置
  processing: false, //是否显示进度条
  optStatus: 0, //0未处理,1处理中，2处理完成

};

//getters
const getters = {};

const mutations = {
  getSettleList(state, list, loading) {
    state.settleList = list;
    state.loading = loading;
  },
  resetData(state) {
	  state.successListLen = 0;
    state.failList = [];
    state.settleList = [];
    state.process = 0;
    state.processing = false;
    state.optStatus = 0;
  },
  upDateComplete(state, payload) {
    state.failList = payload.failList;
    state.successListLen = payload.successLen;
  },
  upDateProcess(state, process) {
    state.process = process
  },
  upDateProcessing(state, processing) {
    state.processing = processing;
  },
  upDateOptStatus(state, status) {
    state.optStatus = status
  }
 };
// actions
const actions = {
	async fetchSettleList(context, args) {
    //根据传过来的数据批量请求详情
    context.commit("resetData");
    var ids = [];
    args.forEach(item => {
      ids.push(item.id)
    })
    var details = await post("/api/fm/web/driver-settle/findDetailByList", {
      settleIdsByList: ids,
      beginSettleFlag: true,
    })
    console.log("details", details);
    details.forEach(atem => {
      var findIndex = args.findIndex(i => {
        return i.id == atem.id
      });
      args[findIndex].accountShowName = atem.accountName + '-' + atem.account;
      args[findIndex].defaultShortfallType = atem.defaultShortfallType;
      args[findIndex].defaultShortfallValue = atem.defaultShortfallValue;
      args[findIndex].defaultUnitPrice = atem.defaultUnitPrice;
      args[findIndex].defaultReconciliationFee = atem.defaultReconciliationFee;
      args[findIndex].smallChangeType = atem.smallChangeType;
      args[findIndex].totalChargeback = atem.totalChargeback;
      args[findIndex].defaultTotalChargeback = atem.totalChargeback;
      console.log("allConsumeAmount", atem.allConsumeAmount);
      if (atem.allConsumeAmount) {
        var allConsumeAmount = atem.allConsumeAmount;
        allConsumeAmount = allConsumeAmount.split('+');
        let num = allConsumeAmount.reduce((old, now) => {
              return Number(old) + Number(now)
        }, 0)
        console.log("num求和", num);
        args[findIndex].paySuccessOilAmount = digital.getAmount(num, 100); //已支付成功消费结算额(油气金额)
        args[findIndex].realConsumeAmount = digital.getAmount(num, 100);
      } else {
        args[findIndex].paySuccessOilAmount = 0;
        args[findIndex].realConsumeAmount = 0;
      }
      //司机支付金额的初始化逻辑，如果不存在，则取结算量*司机单价
      if (atem.realAmount > 0) {
        args[findIndex].realAmount = atem.realAmount || 0;
        args[findIndex].settleAmount = atem.settleAmount || atem.unloadAmount || loadAmount || 0; 
      } else {
        //如果是整车，则直接取单价
        var totalChargeback = atem.totalChargeback || 0;
        var priceMthod = atem.priceMthod;
        var settleAmount = atem.settleAmount || atem.unloadAmount || atem.loadAmount || 0;
        let realAmount = priceMthod == 3 ? atem.realPrice - totalChargeback :  digital.multiply(settleAmount, atem.realPrice || 0) - totalChargeback;
        args[findIndex].realAmount = realAmount > 0 ? digital.toFixed(2, realAmount) : 0
        args[findIndex].settleAmount = atem.unloadAmount || atem.loadAmount || 0;
      }
    })
    

    //第一次进入页面初始化数据
    let arr = [
      "realAmount",
      "realCashAmount",
      "consumeRatePercent",
      "realConsumeAmount",
      "totalChargeback",
      "shortfallVal",
      "shortfallChargeback",
      "reconciliationFee",
      "smallChange",
      "realPrice",
      "settleAmount"
    ];
  
    console.log("初始化数据", args);
    for (let i = 0; i < args.length; i++) {
      console.log("循环次数",args.length, i);
      let item = args[i];

        //如果已经结算且支付过，则根据结算单获取上次支付申请的收款人信息
        if (item.payStatus > 5) {
          var res = await post("/api/fm/web/driver-settle-new/findPayeeByPay", {
            settleNo: item.settleNo
          })
          console.log("银行卡信息", res);
          item.account = res.account;
          item.accountName = res.accountName;
          item.bank = res.bank;
          item.idNo = res.idNo;
          item.payeeMobile = res.payeeMobile;
        } else {
          item.defaultAccount = item.account;
          item.defaultAccountName = item.accountName;
          item.defaultBank = item.bank;
          item.defaultIdNo = item.idNo;
          item.defaultPayeeMobile = item.payeeMobile;
        }

      //结算量初始化不存在则等于卸货量或装货量
      if (!item.settleAmount) {
        item.settleAmount = item.unloadAmount || item.loadAmount || 0
      }

      //计算亏吨相关
      let param = {
        priceMthod: item.priceMthod,
        realPrice: item.realPrice,
        loadAmount: item.loadAmount,
        settleAmount: item.settleAmount || 0,
        defaultShortfallType: item.defaultShortfallType > -1 ? item.defaultShortfallType : -1,
        defaultShortfallValue: item.defaultShortfallValue || 0,
        defaultUnitPrice: item.defaultUnitPrice || 0,
        reconciliationFee: item.defaultReconciliationFee || 0,
        smallChangeType: item.smallChangeType || 0,
        consumeRatePercent: item.consumeRatePercent || 0,
        realAmount: item.realAmount,
        otherDeductions: item.otherDeductions,
      };
      if (item.realAmount) { 
        param.settleAmount = item.settleAmount
        param.realAmount = item.realAmount
      } else {
        param.settleAmount = item.settleAmount;
        console.log(item.unloadAmount, item.realPrice, "价格");
        let realAmount = digital.multiply(item.settleAmount, item.realPrice);
        param.realAmount = digital.toFixed(2, realAmount)
      }
      console.log("params" + i, param)
      //如果该单子为未结算，则扣款项初始值从接口获取
      if (item.status == 1) {
        try {
          var res = await post("/api/fm/web/driver-settle/getResultComputed", param);
          //计算亏吨相关信息
          console.log("结算额", res);
            // item.shortfallChargeback = res.shortfallChargeback || 0;
            item.reconciliationFee = res.reconciliationFee || 0;
            item.totalChargeback = res.totalChargeback || 0;
            item.defaultTotalChargeback = res.totalChargeback || 0;
            var realAmount = ((item.realAmount || 0) - res.totalChargeback) < 0 ? 0 : (item.realAmount || 0) - item.totalChargeback;
            item.realAmount = digital.toFixed(2, realAmount)
          
        } catch (error) {
          
        }
      }
      
      
        //判断是否是固定价格
        if (item.contractPriceMethod == 1) {
          var willPayRealCashAmount = item.realAmount - (item.paySuccessOilAmount || 0) - (item.willPayRealConsumeAmount || 0);
          args[i].willPayRealCashAmount = willPayRealCashAmount > 0 ? Number(willPayRealCashAmount).toFixed(2) : 0
        }
        args[i] = item;
    }
    console.log(args, args.length, "数据");
    var settleList =[...args];
    context.commit("getSettleList", settleList, false);

  },
  inputSettleAmount(context, payload) {
    var settleList = context.state.settleList;
    var index = payload.index;
    var val = payload.val;
    settleList[index].settleAmount = val;
    var arr = [...settleList];
    console.log("arr", arr); //设置结算量
    context.commit("getSettleList", arr, false)
  },
  async changeSettleAmount(context, payload) {
    console.log("context", context , payload);
    var settleList = context.state.settleList;
    var index = payload.index;
    var val = Number(payload.val);
    var regPos = /^[0-9]+.?[0-9]*/;
    if (regPos.test(val)) {
       //如果有亏吨，根据结算量变化计算亏吨
      var res = await context.dispatch("getResultComputed", settleList[index]);
      console.log("结算量有限",res);
      settleList[index] = res;
      var arr = [...settleList];
      context.dispatch("changeNum", {
        settleList: arr,
        index: index
      })
    } else {
      settleList[index].settleAmount = 0;
       //如果有亏吨，根据结算量变化计算亏吨
      var res = await context.dispatch("getResultComputed", settleList[index]);
      console.log("结算量有限",res);
      settleList[index] = res;
      var arr = [...settleList];
      context.dispatch("changeNum", {
        settleList: arr,
        index: index
      })
    }
   
  },
  async getResultComputed(context, payload) {
    //重新计算亏吨信息
    let arr = [
      "realAmount",
      "realCashAmount",
      "consumeRatePercent",
      "realConsumeAmount",
      "totalChargeback",
      "shortfallVal",
      "shortfallChargeback",
      "reconciliationFee",
      "smallChange",
      "otherDeductions",
    ];
    let arrGet = [
      "priceMthod",
      "realPrice",
      "loadAmount",
      "settleAmount",
      "defaultShortfallType",
      "defaultShortfallValue",
      "defaultUnitPrice",
      "reconciliationFee",
      "smallChangeType",
      "consumeRatePercent",
      "realAmount",
      "otherDeductions"
    ];
    let param = {};
    _.forIn(arrGet, function(value, key) {
      param[value] = payload[value];
    });
    if(payload.realConsumeAmount){
      param.realConsumeAmount = Number(this.realConsumeAmount);
      param.consumeRatePercent = '';
    } else {
      param.realCashAmount = "";
    }
    // debugger
      //先开票后支付也需要计算亏吨逻辑
      try {
        var res = await post("api/fm/web/driver-settle/getResultComputed", param);
        payload.totalChargeback = res.totalChargeback;
        payload.smallChangeType = res.smallChangeType;
        payload.smallChange = res.smallChange;
        payload.shortfallVal = res.shortfallVal;
        payload.shortfallChargeback = res.shortfallChargeback;
        return payload;
      } catch (error) {
        return payload;
      }
  },
  //修改司机单价
  inputRealPrice(context, payload) {
    var settleList = context.state.settleList;
    var index = payload.index;
    var val = payload.val;   
    settleList[index].realPrice = val;
    context.commit("getSettleList", settleList, false)
    
  },
  changeRealPrice(context, payload) {
    var settleList = context.state.settleList;
    var index = payload.index;
    var realPrice = Number(payload.val);
    var regPos = /^[0-9]+.?[0-9]*/;
    if (regPos.test(realPrice)) {
      context.dispatch("changeNum", {
        settleList: settleList,
        index: index
      })
    } else {
      settleList[index].realPrice = 0;
      context.dispatch("changeNum", {
        settleList: settleList,
        index: index
      })
    }
   
  },
  //修改扣款项
  inputTotalChargeback(context, payload) {
    var settleList = context.state.settleList;
    var index = payload.index;
    var val = payload.val;
    settleList[index].totalChargeback = val;
    var arr = [...settleList];
    console.log("arr", arr);
    context.commit("getSettleList", arr, false)
  },
  changeTotalChargeback(context, payload) {
    var settleList = context.state.settleList;
    var index = payload.index;
    var regPos = /^-?[0-9]+.?[0-9]*/;
    var val = Number(payload.val);
    var defaultTotalChargeback = settleList[index].defaultTotalChargeback || 0;
    var otherDeductions = settleList[index].otherDeductions || 0;
    if (regPos.test(val)) {
      settleList[index].otherDeductions = Number(val) - Number(defaultTotalChargeback) + Number(otherDeductions);
      settleList[index].totalChargeback = val;
    } else {
      settleList[index].otherDeductions = 0 - Number(defaultTotalChargeback) + Number(otherDeductions);
      settleList[index].totalChargeback = 0;
    }
    settleList[index].defaultTotalChargeback = settleList[index].totalChargeback;

    context.dispatch("changeNum", {
      settleList: settleList,
      index: index
    })
  },
  inputRealCashAmount(context,payload) {//现金支付金额
    var settleList = context.state.settleList;
    var index = payload.index;
    var val = payload.val;
    settleList[index].willPayRealCashAmount = val;
    var arr = [...settleList];
    context.commit("getSettleList", arr, false)
  },
  changeRealCashAmount(context, payload) {
    var settleList = context.state.settleList;
    var index = payload.index;
    var val = Number(payload.val);
    var regPos = /^[0-9]+.?[0-9]*/;
    if (regPos.test(val)) {
      settleList[index].willPayRealCashAmount = val;
    } else {
      settleList[index].willPayRealCashAmount = 0;
    }
    context.dispatch("changeNum", {
      settleList: settleList,
      index: index
    })
  },
  inputRealConsumeAmount(context, payload) {
    //油气金额修改
    var settleList = context.state.settleList;
    var index = payload.index;
    var val = payload.val;
    settleList[index].willPayRealConsumeAmount = val;
    var arr = [...settleList];
    context.commit("getSettleList", arr, false)
  },
  changeRealConsumeAmount(context, payload) {
    var settleList = context.state.settleList;
    var index = payload.index;
    var val = Number(payload.val);
    var paySuccessOilAmount = settleList[index].paySuccessOilAmount;
    var regPos = /^[0-9]+.?[0-9]*/;
    if (regPos.test(val)) {
      val = val ? Number(val).toFixed(2) : '';
      settleList[index].willPayRealConsumeAmount = val;
    } else {
      val = 0;
      settleList[index].willPayRealConsumeAmount = val;
    }
   
    var realConsumeAmount = digital.accDiv(val, 100) + digital.accDiv(paySuccessOilAmount, 100);
    settleList[index].realConsumeAmount = digital.getAmount(realConsumeAmount, 100); //计算总的消费结算额
    //油气金额修改后动态计算现金结算额
    var willPayRealCashAmount = settleList[index].willPayRealCashAmount;
    var maxPayRealCashAmount = 0;
    if (settleList[index].status > 1) {
      //已结算
      maxPayRealCashAmount = settleList[index].notPayAmount/100 - settleList[index].willPayRealConsumeAmount;
    } else {
      //未结算
      if (settleList[index].priceMthod == 3) {
        maxPayRealCashAmount = settleList[index].realPrice - settleList[index].totalChargeback - settleList[index].paySuccessOilAmount - settleList[index].willPayRealConsumeAmount
      } else {
        maxPayRealCashAmount = settleList[index].realPrice*settleList[index].settleAmount - settleList[index].totalChargeback - settleList[index].paySuccessOilAmount - settleList[index].willPayRealConsumeAmount
      }
    }
    if (maxPayRealCashAmount < 0) {
      //油气支付金额修改后司机支付现金金额为负数
      settleList[index].willPayRealConsumeAmount = 0;
      var realConsumeAmount = 0 + digital.accDiv(paySuccessOilAmount, 100);
      settleList[index].realConsumeAmount = digital.getAmount(realConsumeAmount, 100); //计算总的消费结算额
    } else {
      if (settleList[index].contractPriceMethod == 1) {
        //固定价格的现金金额取最大值
        settleList[index].willPayRealCashAmount = maxPayRealCashAmount < 0 ? 0 : maxPayRealCashAmount.toFixed(2)
      }
    }

    var arr = [...settleList];
    context.commit("getSettleList", arr, false)
  },
  //重置银行卡
  resetBank(context, payload) {
    var index = payload.index;
    var settleList = context.state.settleList;
    settleList[index].account =  settleList[index].defaultAccount;
    settleList[index].idNo =  settleList[index].defaultIdNo;
    settleList[index].accountName =  settleList[index].defaultAccountName;
    settleList[index].bank =  settleList[index].defaultBank;
    settleList[index].payeeMobile =  settleList[index].defaultPayeeMobile;
    settleList[index].accountShowName = settleList[index].defaultAccountName + '-' + settleList[index].defaultAccount;
    var arr = [...settleList];
    context.commit("getSettleList", arr, false);
  },
  upDateBank(context, payload) {
    //修改银行卡
    var index = payload.index;
    var settleList = context.state.settleList;
    var bankItem = payload.bankItem;
    settleList[index].account = bankItem.account;
    settleList[index].idNo =  bankItem.idNo;
    settleList[index].accountName =  bankItem.accountName;
    settleList[index].bank =  bankItem.bank;
    settleList[index].payeeMobile =  bankItem.payeeMobile;
    settleList[index].accountShowName = bankItem.accountName + '-' + bankItem.account;
    var arr = [...settleList];
    context.commit("getSettleList", arr, false);
  },

  async changeNum(context, payload) {
    var settleList = payload.settleList;
    var index = payload.index;
    var item = settleList[index];
    var settleAmount = item.settleAmount || 0; //结算量
    var realPrice = item.realPrice || 0; //司机单价
    var totalChargeback = item.totalChargeback || 0; //扣款金额
    var realAmount = item.priceMthod == 3 ? realPrice - totalChargeback : settleAmount*realPrice - totalChargeback; //司机支付金额
    if (realAmount < 0) {
      item.realAmount = 0
    } else {
      item.realAmount = digital.toFixed(1, realAmount);
    }
   
    if (item.status > 1) {
      //已结算
      var willPayRealCashAmount = item.notPayAmount/100 - (item.willPayRealConsumeAmount || 0);
      willPayRealCashAmount = willPayRealCashAmount.toFixed(2);
      if (item.contractPriceMethod == 1) {
        //固定价格的单子
        if (willPayRealCashAmount < 0) {
          item.willPayRealCashAmount = 0;
        } else {
          item.willPayRealCashAmount = willPayRealCashAmount ? Number(willPayRealCashAmount).toFixed(2) : '';
        }
       
      } else {
        var willPayRealCashAmount = Number(item.willPayRealCashAmount).toFixed(2) - Number(willPayRealCashAmount).toFixed(2) > 0 ? 0 : item.willPayRealCashAmount;
        item.willPayRealCashAmount = willPayRealCashAmount > 0 ?  Number(willPayRealCashAmount).toFixed(2) : 0;
      }

    } else {
      var willPayRealCashAmount = realAmount - (item.paySuccessOilAmount || 0) - (item.willPayRealConsumeAmount || 0);
      if (item.contractPriceMethod == 1) {
        //固定价格的单子
        item.willPayRealCashAmount = willPayRealCashAmount > 0 ? Number(willPayRealCashAmount).toFixed(2) : 0;
      } else {
        var willPayRealCashAmount = Number(item.willPayRealCashAmount).toFixed(2) - Number(realAmount).toFixed(2) > 0 ? 0 : item.willPayRealCashAmount;
        item.willPayRealCashAmount = willPayRealCashAmount > 0 ?  Number(willPayRealCashAmount).toFixed(2) : 0;
      }
    }
   
    settleList[index] = item;
    console.log("settleList", settleList); //数据啊
    var arr = [...settleList];
    context.commit("getSettleList", arr, false);
  },
  //批量结算支付确认
  async batchSettle(context, args) {
    var successList = [], failList = [];
    context.commit("upDateProcessing", true);
    context.commit("upDateOptStatus", 1);
    var optLength = args.length;
    for(var i =0; i < args.length; i ++) {
      var item = args[i];
      var status = item.status;
      var realConsumeAmount = item.realConsumeAmount;
      var willPayRealConsumeAmount = item.willPayRealConsumeAmount;
      if (willPayRealConsumeAmount > 0) {
        //有油气金额，则先计算油气金额后调用结算，结算成功后调用油气支付，油气支付失败，调用重新结算接口。
        var settleRsp =  await context.dispatch("dispatchSettle", item);
        if (settleRsp.optStatus == 0) {
          //结算失败
          failList.push(settleRsp)
        } else {
          var includeTaxAmount = settleRsp.includeTaxAmount; //结算成功后返回的含税金额
          try {
              //结算成功后添加消费事件
              await post1("/api/fm/web/chargeCard/consumerEvents", {
                carrId: item.carrId,
                consumeType: 1,
                realConsumeAmount: willPayRealConsumeAmount*100,
                sendId: item.sendId,
                supplier: 3
              })

              var saveParams = {
                carrId: item.carrId,
                carrOrgId: item.carrOrgId,
                consumeType: 1,
                driverId: item.driverId,
                plateNo: item.plateNo,
                realConsumeAmount: willPayRealConsumeAmount,
                supplier: 3,
                taskId: item.taskId,
                taskType: "货运中国网",
              }
              if (status == 1) {
                saveParams.isAddConsume = 1; //未结算的单子传该字段，已结算的单子不传
              }
              await post1("/api/fm/web/consume/save", saveParams)
                  
            //消费事件添加成功，走支付
            var settleRsp =  await context.dispatch("signalPay", {
              optItem: item,
              includeTaxAmount: includeTaxAmount
            });
            console.log("settleRsp", settleRsp);
            if (settleRsp.optStatus == 0) {
              failList.push(settleRsp)
            } else {
              successList.push(settleRsp);
            }
          } catch (error) {
            console.log("error", error);
            var message = ""
            if ((error.data && error.data.retDesc == "系统异常") || error == "系统异常") {
              message = "添加油气系统异常"
            } else {
              message = error.data ? error.data.retDesc : error
            }
            failList.push({
              taskId: item.taskId,
              message: message,
            })
            //消费事件添加不成功，减掉添加的消费事件后重新结算，并且司机现金金额重新计算
            if (args[i].contractPriceMethod == 1) {
              //固定价格，司机现金金额还原为最大值
              args[i].willPayRealCashAmount = args[i].willPayRealCashAmount + args[i].willPayRealConsumeAmount;
            }
            args[i].willPayRealConsumeAmount = 0;
            args[i].realConsumeAmount = args[i].paySuccessOilAmount;
            args[i].version = args[i].version + 1;

            var settleRsp =  await context.dispatch("settle", item);
            console.log("settleRsp", settleRsp);
            if (settleRsp.optStatus == 0) {
              failList.push(settleRsp)
            } else {
              successList.push(settleRsp);
            }

          }
        }
      
          
      } else {
        //没有新的消费事件，直接结算
        var settleRsp =  await context.dispatch("settle", item);
        console.log("settleRsp", settleRsp);
        if (settleRsp.optStatus == 0) {
          failList.push(settleRsp)
        } else {
          successList.push(settleRsp);
        }
      }
      var process = (i+1)/optLength*100;
      process = Math.round(process);
      console.log("process", process);
      context.commit("upDateProcess", process);
    }
    setTimeout(() => {
      context.commit("processing", false);
      context.commit("upDateOptStatus", 2);
      context.commit("upDateComplete", {
        successLen: successList.length,
        failList: failList,
      })
    }, 1000)
  },
  async dispatchSettle(context, args) {
    //只做结算操作
     //结算
     var settleList = new Object();
     settleList.drs = new Object();
     settleList.task = args;
     var realConsumeAmount = args.realConsumeAmount || 0;
     if (realConsumeAmount > 0) {
       settleList.drs.consumeAmountNoPay = 0; //消费比例元转分
     }
     settleList.task.realConsumeAmount = realConsumeAmount; //总的消费结算额
     settleList.drs.realConsumeAmount = realConsumeAmount; //总的消费结算额
     settleList.drs.settleNo = args.settleNo;
     settleList.drs.carrId = args.carrId;
     settleList.drs.carrOrgId = args.carrOrgId;
     settleList.drs.settleAmount = args.settleAmount;
     settleList.drs.realPrice = args.realPrice;
     settleList.drs.realAmount = args.realAmount;
 
     var consumeRatePercent = digital.divide(realConsumeAmount, args.realAmount);
     consumeRatePercent = digital.multiply(consumeRatePercent, 100);
     settleList.drs.consumeRatePercent = consumeRatePercent.toFixed(1);
     settleList.task.consumeRatePercent = consumeRatePercent.toFixed(1);
     console.log()
     var realCashAmount = digital.accDiv(args.realAmount, 100) - digital.accDiv(realConsumeAmount, 100);
     console.log("realCashAmount", realCashAmount);
     settleList.drs.realCashAmount = digital.getAmount(realCashAmount, 100) //司机支付现金金额等于司机支付金额-消费结算额
     var hasShort = args.hasOwnProperty("smallChangeType");
     if (hasShort) {
       //判断是否有亏吨
       settleList.drs.smallChange = args.smallChangeType;
       settleList.drs.shortfallChargeback = args.shortfallChargeback;
       settleList.drs.shortfallVal = args.shortfallVal;
     }
     settleList.drs.reconciliationFee = args.reconciliationFee || 0;
     settleList.drs.totalChargeback = args.totalChargeback || 0;
     //计算其他扣款项
     settleList.drs.otherDeductions = args.otherDeductions;
     settleList.drs.id = args.id;
     settleList.drs.version = args.version;
     settleList.drs.contractId = args.contractId;
     settleList.drs.priceMthod = args.priceMthod;
     settleList.drs.loadAmount = args.loadAmount;
     settleList.drs.unloadAmount = args.unloadAmount;
     settleList.drs.unit = args.unit;
     settleList.drs.plateNo = args.plateNo;
     console.log("结算参数", settleList);
 
     try {
       var settleRsp = await post1("/api/fm/web/driver-settle-new/updateDetail", settleList);
       console.log("settleRsp", settleRsp); //结算信息
        if (settleRsp.data.retCode != "0000000") {
         //结算失败直接返回
         var errorMessage = settleRsp.data.retDesc;
         var failItem = {
           taskId: args.taskId,
           message: errorMessage == "系统异常" ? '结算系统异常' : errorMessage,
           optStatus: 0
         };
         return failItem;
        }
        var successItem = {
          includeTaxAmount: settleRsp.data.rspBody,
        }
        return successItem;
     } catch (error) {
       var errorMessage = error.data.retDesc;
       var failItem = {
         taskId: args.taskId,
         message: errorMessage == "系统异常" ? '结算系统异常' : errorMessage,
         optStatus: 0
       };
       return failItem;
     }
     
  },
  async signalPay(context, payload) {
     //判断是否走支付
     var args = payload.optItem;
     var includeTaxAmount = payload.includeTaxAmount;//结算后返回的含税金额
     var willPayRealCashAmount = args.willPayRealCashAmount;
     if (!willPayRealCashAmount || willPayRealCashAmount == 0) {
       //未填写现金支付金额，不走支付
       var successItem = {
         taskId: args.taskId,
         optStatus: 1
       }
       return successItem
     }
     var payAmount = digital.accDiv(args.willPayRealCashAmount, 100);
     var payParams = {
       account: args.account,
       accountName: args.accountName,
       amount: digital.accDiv(args.realAmount, 100),
       bank: args.bank,
       carrId: args.carrId,
       carrName: args.carrName,
       carrOrgId: args.carrOrgId,
       carrOrgName: args.carrOrgName,
       contractId: args.contractId,
       driverId: args.driverId,
       driverName: args.driverName,
       driverPhone: args.driverPhone,
       driverSettleId: args.id,
       driverSettleNo: args.settleNo,
       idNo: args.idNo,
       includeTaxAmount: includeTaxAmount,
       payAmount: payAmount,
       payChannel: args.payChannel,
       plateNo: args.plateNo,
       receiveDt: args.receiveDt,
       senderId: args.senderId,
       senderName: args.senderName,
       senderOrgId: args.senderOrgId,
       senderOrgName: args.senderOrgName,
       startDt: args.startDt,
       taskId: args.taskId,
       customerNumber: args.customerNumber,
       payeeMobile: args.payeeMobile,
     }
     try {
       var payRsp = await post("/api/fm/web/driver-settle-new/payApply", payParams)
       console.log("payRsp", payRsp); //支付的数据
       if (payRsp != "ok") {
         var failItem = {
           taskId: args.taskId,
           message: payRsp == "系统异常" ? '支付系统异常' : payRsp,
           optStatus: 0,
         }
         return failItem
       } else {
         var successItem = {
           taskId: args.taskId,
           optStatus: 1
         }
         return successItem
       }
     } catch (error) {
       var failItem = {
         taskId: args.taskId,
         message: error.data.rspBody == "系统异常" ? "支付系统异常" : error.data.rspBody,
         optStatus: 0,
       }
       return failItem
       
     }

  },
  async settle(context,args) {
    //结算
    var settleList = new Object();
    settleList.drs = new Object();
    settleList.task = args;
    var realConsumeAmount = args.realConsumeAmount || 0;
    if (realConsumeAmount > 0) {
      settleList.drs.consumeAmountNoPay = 0; //消费比例元转分
    }
    settleList.task.realConsumeAmount = realConsumeAmount; //总的消费结算额
    settleList.drs.realConsumeAmount = realConsumeAmount; //总的消费结算额
    settleList.drs.settleNo = args.settleNo;
    settleList.drs.carrId = args.carrId;
    settleList.drs.carrOrgId = args.carrOrgId;
    settleList.drs.settleAmount = args.settleAmount;
    settleList.drs.realPrice = args.realPrice;
    settleList.drs.realAmount = args.realAmount;

    var consumeRatePercent = digital.divide(realConsumeAmount, args.realAmount);
    consumeRatePercent = digital.multiply(consumeRatePercent, 100);
    settleList.drs.consumeRatePercent = consumeRatePercent.toFixed(1);
    settleList.task.consumeRatePercent = consumeRatePercent.toFixed(1);
    console.log()
    var realCashAmount = digital.accDiv(args.realAmount, 100) - digital.accDiv(realConsumeAmount, 100);
    console.log("realCashAmount", realCashAmount);
    settleList.drs.realCashAmount = digital.getAmount(realCashAmount, 100) //司机支付现金金额等于司机支付金额-消费结算额
    var hasShort = args.hasOwnProperty("smallChangeType");
    if (hasShort) {
      //判断是否有亏吨
      settleList.drs.smallChange = args.smallChangeType;
      settleList.drs.shortfallChargeback = args.shortfallChargeback;
      settleList.drs.shortfallVal = args.shortfallVal;
    }
    settleList.drs.reconciliationFee = args.reconciliationFee || 0;
    settleList.drs.totalChargeback = args.totalChargeback || 0;
    //计算其他扣款项
    settleList.drs.otherDeductions = args.otherDeductions;
    settleList.drs.id = args.id;
    settleList.drs.version = args.version;
    settleList.drs.contractId = args.contractId;
    settleList.drs.priceMthod = args.priceMthod;
    settleList.drs.loadAmount = args.loadAmount;
    settleList.drs.unloadAmount = args.unloadAmount;
    settleList.drs.unit = args.unit;
    settleList.drs.plateNo = args.plateNo;
    console.log("结算参数", settleList);

    try {
      var settleRsp = await post1("/api/fm/web/driver-settle-new/updateDetail", settleList);
      console.log("settleRsp", settleRsp); //结算信息
      if (settleRsp.data.retCode != "0000000") {
        //结算失败直接返回
        var errorMessage = settleRsp.data.retDesc;
        var failItem = {
          taskId: args.taskId,
          message: errorMessage == "系统异常" ? '结算系统异常' : errorMessage,
          optStatus: 0
        };
        return failItem;
      }
    } catch (error) {
      var errorMessage = error.data.retDesc;
      var failItem = {
        taskId: args.taskId,
        message: errorMessage == "系统异常" ? '结算系统异常' : errorMessage,
        optStatus: 0
      };
      return failItem;
    }
    
    //判断是否走支付
    var willPayRealCashAmount = args.willPayRealCashAmount;
    if (!willPayRealCashAmount || willPayRealCashAmount == 0) {
      //未填写现金支付金额，不走支付
      var successItem = {
        taskId: args.taskId,
        optStatus: 1
      }
      return successItem
    }
    var includeTaxAmount = settleRsp.data.rspBody; //结算后返回的含税金额
    var payAmount = digital.accDiv(args.willPayRealCashAmount, 100);
    var payParams = {
      account: args.account,
      accountName: args.accountName,
      amount: digital.accDiv(args.realAmount, 100),
      bank: args.bank,
      carrId: args.carrId,
      carrName: args.carrName,
      carrOrgId: args.carrOrgId,
      carrOrgName: args.carrOrgName,
      contractId: args.contractId,
      driverId: args.driverId,
      driverName: args.driverName,
      driverPhone: args.driverPhone,
      driverSettleId: args.id,
      driverSettleNo: args.settleNo,
      idNo: args.idNo,
      includeTaxAmount: includeTaxAmount,
      payAmount: payAmount,
      payChannel: args.payChannel,
      plateNo: args.plateNo,
      receiveDt: args.receiveDt,
      senderId: args.senderId,
      senderName: args.senderName,
      senderOrgId: args.senderOrgId,
      senderOrgName: args.senderOrgName,
      startDt: args.startDt,
      taskId: args.taskId,
      customerNumber: args.customerNumber,
      payeeMobile: args.payeeMobile,
    }
    try {
      var payRsp = await post("/api/fm/web/driver-settle-new/payApply", payParams)
      console.log("payRsp", payRsp); //支付的数据
      if (payRsp != "ok") {
        var failItem = {
          taskId: args.taskId,
          message: payRsp == '系统异常' ? '支付系统异常' : payRsp,
          optStatus: 0,
        }
        return failItem
      } else {
        var successItem = {
          taskId: args.taskId,
          optStatus: 1
        }
        return successItem
      }
    } catch (error) {
      var failItem = {
        taskId: args.taskId,
        message: error.data.rspBody == '系统异常' ? '支付系统异常' : error.data.rspBody,
        optStatus: 0,
      }
      return failItem
      
    }
   
  },
  upDatePercentNowPrice(context, payload) {
    //根据比例更新现金支付金额
    var settleList = context.state.settleList;
    settleList.forEach(item => {
      var realAmount = item.realAmount || 0; //司机支付金额
      var willPayRealCashAmount = realAmount*payload/100;
      if (item.contractPriceMethod != 1) {//非固定价格且已结算才可以计算比例修改
        var status = item.status; //判断是否结算
        if (status == 1) {
          //未结算
          var maxMount = item.realAmount - item.paySuccessOilAmount - item.willPayRealConsumeAmount;
          if (willPayRealCashAmount - maxMount > 0) {
            item.willPayRealCashAmount =  0
          } else {
            item.willPayRealCashAmount = willPayRealCashAmount > 0 ? willPayRealCashAmount.toFixed(2) : 0;
          }
        } else {
          var notPayAmount = item.notPayAmount || 0;//司机支付金额不能大于未支付金额(减掉新申请的油气)
          var willPayRealConsumeAmount = item.willPayRealConsumeAmount || 0;
          var maxMount = notPayAmount/100 - willPayRealConsumeAmount;
          if (notPayAmount/100 - willPayRealConsumeAmount < willPayRealCashAmount) {
            item.willPayRealCashAmount = 0;
          } else {
            item.willPayRealCashAmount = willPayRealCashAmount > 0 ? Number(willPayRealCashAmount).toFixed(2) : 0;
          }
        }
       
      }
    })
    var arr = [...settleList];
    context.commit("getSettleList", arr, false);
    
  },
  upDateNowPrice(context, payload) {
    var settleList = context.state.settleList;
    settleList.forEach(item => {
      var willPayRealCashAmount = payload;
      if (item.contractPriceMethod != 1) {//非固定价格才允许修改
        var status = item.status; //判断是否结算
        if (status == 1) {
          //未结算
          var maxMount = item.realAmount - item.paySuccessOilAmount - item.willPayRealConsumeAmount;
          if (Number(willPayRealCashAmount) - Number(maxMount) > 0) {
            item.willPayRealCashAmount =  0
          } else {
            item.willPayRealCashAmount = willPayRealCashAmount > 0 ? willPayRealCashAmount.toFixed(2) : 0;
          }
        } else {
          var notPayAmount = item.notPayAmount || 0;//司机支付金额不能大于未支付金额(减掉新申请的油气)
          var willPayRealConsumeAmount = item.willPayRealConsumeAmount || 0;
          if (notPayAmount/100 - willPayRealConsumeAmount < willPayRealCashAmount) {
            item.willPayRealCashAmount = 0;
          } else {
            item.willPayRealCashAmount = willPayRealCashAmount > 0 ? Number(willPayRealCashAmount).toFixed(2) : 0;
          }
        }
     
        
      }
      
    })
    var arr = [...settleList];
    context.commit("getSettleList", arr, false);
  },
  upDatePercentOilPrice(context, payload) {
    //批量更新油气支付金额
    var settleList = context.state.settleList;
    settleList.forEach(item => {
      if (item.contractPriceMethod != 1) {
        //非固价才允许添加油气金额
        var realAmount = item.realAmount || 0; //司机支付金额
        var willPayRealConsumeAmount = realAmount*payload/100;
        item.willPayRealConsumeAmount = willPayRealConsumeAmount;
        item.realConsumeAmount = (item.paySuccessOilAmount || 0) + (willPayRealConsumeAmount || 0);
        var willPayRealCashAmount = item.willPayRealCashAmount || 0;
        var notPayAmount = item.notPayAmount || 0;
        var status = item.status; //判断的是否结算
        if (status == 1) {
          //未结算
          var mount = item.priceMthod == 3 ? item.realPrice : item.settleAmount* item.realPrice;//整车司机支付金额取单价
          diff = mount - (item.totalChargeback || 0) - (item.paySuccessOilAmount || 0) - willPayRealConsumeAmount;
          if (diff < 0) {
            item.willPayRealConsumeAmount = 0;
            item.realConsumeAmount = item.paySuccessOilAmount || 0;
          }
        } else {
          var diff = notPayAmount/100 - willPayRealConsumeAmount;
          //改变油气金额后如果司机现金支付金额大于未支付金额，则重置现金支付金额为最大值
          if (notPayAmount/100 - willPayRealConsumeAmount < willPayRealCashAmount) {
            item.willPayRealConsumeAmount = 0
            item.realConsumeAmount = item.paySuccessOilAmount || 0;
          }
        }
   
      }

    })
    var arr = [...settleList];
    context.commit("getSettleList", arr, false);
  },
  upDateOilPrice(context, payload) {
    var settleList = context.state.settleList;
    settleList.forEach(item => {
      if (item.contractPriceMethod != 1) {
        var willPayRealConsumeAmount = payload;
        item.willPayRealConsumeAmount = willPayRealConsumeAmount;
        var willPayRealCashAmount = item.willPayRealCashAmount;
        item.realConsumeAmount = (item.paySuccessOilAmount || 0) + (willPayRealConsumeAmount || 0);
        var mount = 0, diff = 0;
     
        if (item.status > 1) {
          //已结算
          diff = item.notPayAmount/100 - (willPayRealConsumeAmount || 0);
        } else {
          //未结算
          mount = item.priceMthod == 3 ? item.realPrice : item.settleAmount* item.realPrice;//整车司机支付金额取单价
          diff = mount - (item.totalChargeback || 0) - (item.paySuccessOilAmount || 0) - willPayRealConsumeAmount;
        }
        if (diff < willPayRealCashAmount) {
          //计算的现金金额比最大值大，则取最大值
          item.willPayRealConsumeAmount = 0;
          item.realConsumeAmount = (item.paySuccessOilAmount || 0);
        }
      }
    })
    var arr = [...settleList];
    context.commit("getSettleList", arr, false);
  },
  upDateAllNowPrice(context) {
    //剩余金额全部支付
    var settleList = context.state.settleList;
    settleList.forEach(item => {
      //判断该单子是否已结算
      var contractPriceMethod = item.contractPriceMethod; //判断是否是固定价格
      var status = item.status; //大于1为已结算
      if (contractPriceMethod != 1) { //非固定价格且已结算
        if (status > 1) {
          var remindPrice = digital.getAmount(item.notPayAmount, 100) - (item.willPayRealConsumeAmount || 0);
          item.willPayRealCashAmount = remindPrice ? Number(remindPrice).toFixed(2) : ''
        } else {
          var remindPrice = item.realAmount - (item.willPayRealConsumeAmount || 0) - (item.paySuccessOilAmount || 0);
          item.willPayRealCashAmount = remindPrice > 0 ? Number(remindPrice).toFixed(2) : 0
        }
        
      }
      
    })
    var arr = [...settleList];
    context.commit("getSettleList", arr, false);

  },
  deleteRow(context, index) {
    var settleList = context.state.settleList;
    settleList.splice(index, 1)
    var arr = [...settleList];
    context.commit("getSettleList", arr, false);
  }

};

export default {
  // namespaced: true,
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/DriverSettlementTwo.js